const state = {
    events:[
       {
       allDay:false,
       end:'2022-10-04T10:30:00',
       start:'2022-10-04T10:30:00',
       title:"VUEX"}
    ]
  };
  
  const getters = {
   EVENTS: state => state.events
  };
  
  const mutations = {
    ADD_EVENT:(state,event) => {
        state.events.push(event)    
    },

    SET_ALERT: (state, value) => {
      state.alert = value;
    }
  };
  
  const actions = {};
  
  export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
  };